import {
  detectAudioContainerFromBytes,
  getMimeTypeForAudioContainer,
} from '../audio'

export function normalizeMimeType(type?: string | null): string | null {
  const normalized = type?.trim()
  return normalized && normalized.length > 0 ? normalized : null
}

export function inferMimeTypeFromBytes(
  data: ArrayBuffer | Uint8Array,
  preferredType?: string | null,
  fallbackType?: string | null,
): string | null {
  const normalizedPreferredType = normalizeMimeType(preferredType)
  if (normalizedPreferredType) {
    return normalizedPreferredType
  }

  const normalizedFallbackType = normalizeMimeType(fallbackType)
  if (normalizedFallbackType) {
    return normalizedFallbackType
  }

  const detectedContainer = detectAudioContainerFromBytes(data)
  return getMimeTypeForAudioContainer(detectedContainer)
}

export async function serializeBlobField(
  blob: Blob | null | undefined,
  existingType?: string | null,
): Promise<{ data: ArrayBuffer | null; type: string | null }> {
  if (!blob) return { data: null, type: normalizeMimeType(existingType) }
  const buffer = await blob.arrayBuffer()
  return { data: buffer, type: inferMimeTypeFromBytes(buffer, blob.type, existingType) }
}

export function hydrateBlob(data?: ArrayBuffer | null, type?: string | null): Blob | null {
  if (!data) return null
  const hydratedType = inferMimeTypeFromBytes(data, type)
  return hydratedType ? new Blob([data], { type: hydratedType }) : new Blob([data])
}

export async function serializeChunkBlob(
  blob: Blob | undefined,
  existingType?: string | null,
): Promise<{ data: ArrayBuffer | null; type: string | null }> {
  if (!blob) return { data: null, type: normalizeMimeType(existingType) }
  const buffer = await blob.arrayBuffer()
  return { data: buffer, type: inferMimeTypeFromBytes(buffer, blob.type, existingType) }
}
